import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { api } from "@/lib/api";

const MAX = 8;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | timeout | error
  const [info, setInfo] = useState(null);
  const { clear } = useCart();

  useEffect(() => {
    window.scrollTo(0, 0);
    let attempts = 0;
    let timer;
    const poll = async () => {
      if (!sessionId) { setState("error"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setState("paid"); clear(); return; }
        if (attempts >= MAX) { setState("timeout"); return; }
        attempts += 1;
        timer = setTimeout(poll, 2000);
      } catch {
        setState("error");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="pt-[148px] min-h-screen flex items-center justify-center px-5" data-testid="payment-success-page">
      <div className="max-w-lg w-full p-10 text-center" style={{ background: "var(--white)", border: "1px solid var(--border)" }}>
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto animate-spin" size={48} style={{ color: "var(--orange)" }} />
            <p className="font-display font-bold text-2xl mt-6">Validation du paiement…</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="mx-auto" size={56} style={{ color: "var(--orange)" }} />
            <h1 className="font-display font-black text-3xl mt-6" data-testid="payment-paid-title">Paiement confirmé</h1>
            <p className="mt-4 text-lg" style={{ color: "var(--ink-2)" }}>
              Merci pour votre commande{info?.product_name ? ` : ${info.product_name}` : ""}. Un conseiller ALDOL-SOLUTIONS vous contacte pour la livraison.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <a href={`${process.env.REACT_APP_BACKEND_URL}/api/orders/${sessionId}/invoice`} target="_blank" rel="noopener noreferrer"
                className="btn-primary inline-block px-8 py-4 font-semibold" data-testid="download-invoice-btn">
                Télécharger ma facture (PDF)
              </a>
              <Link to="/catalogue" className="btn-outline inline-block px-8 py-4 font-semibold">Retour au catalogue</Link>
            </div>
          </>
        )}
        {(state === "timeout" || state === "error") && (
          <>
            <p className="font-display font-bold text-2xl">Statut en attente</p>
            <p className="mt-4" style={{ color: "var(--ink-2)" }}>Le paiement est en cours de traitement. Vous recevrez une confirmation par email.</p>
            <Link to="/" className="btn-outline inline-block mt-8 px-8 py-4 font-semibold">Accueil</Link>
          </>
        )}
      </div>
    </div>
  );
}
